import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom";
import { getUserAuth, setInvestorReportPath } from "../../utils/LocalStorageUtils";
import { BASE_URL } from "../../utils/constants/constants";
import { getUserDetails } from "../apis/apis";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function InvestorReport() {

    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const filePath = location.pathname.replace("/user/investor-report/", "");
    const history = useHistory();

    const fetchInvestorDetails = () => {
        getUserDetails()
            .then((result) => {
                if (result.data.loginEnabled === 0) {
                    localStorage.clear();
                    setIsLoading(false);
                    history.push("/")
                }
            })
    }

    useEffect(() => {
        setIsLoading(true);
        localStorage.removeItem("investor_report_path");
        if (getUserAuth()) {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchInvestorDetails();
    }, []);

    return isLoading ? (
        <div className="preview-loader-wrapper">
            <img className="logo" src={'/assets/logo.svg'} alt={'logo'} style={{ cursor: 'pointer', width: '130px', height: '50px' }} />
        </div>
    ) : (<div style={{ height: "100vh" }}>
        <iframe
            src={`${BASE_URL}/${filePath}`}
            style={{ width: "100%", height: "100%" }}
        />
    </div>);
}

export default InvestorReport;